﻿import request from '@/config/axios'

// 岗位 VO
export interface PositionVO {
  id?: string | number
  code: string
  name: string
  description?: string
  salaryMode?: string
  performanceMetrics?: string
  sort: number
  status: number
  createTime?: Date
}

// 获取岗位分页
export const getPositionPage = (params: any) => {
  return request.get({ url: '/hotel/position/page', params })
}

// 获取岗位详情
export const getPosition = (id: string | number) => {
  return request.get({ url: '/hotel/position/get?id=' + id })
}

// 创建岗位
export const createPosition = (data: PositionVO) => {
  return request.post({ url: '/hotel/position/create', data })
}

// 更新岗位
export const updatePosition = (data: PositionVO) => {
  return request.put({ url: '/hotel/position/update', data })
}

// 删除岗位
export const deletePosition = (id: string | number) => {
  return request.delete({ url: '/hotel/position/delete?id=' + id })
}

// 批量删除岗位
export const deletePositionList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/position/delete-list?ids=' + ids.join(',') })
}

// 获取全部岗位列表
export const getPositionList = (params?: any) => {
  return request.get({ url: '/hotel/position/list-all-simple', params })
}
